var RADIAN = Math.PI / 180;

var toRadian = function toRadian(degree) {
  return RADIAN * degree;
};

module.exports = toRadian;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/math/to-radian.js
// module id = 68
// module chunks = 0 1 2